<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>회원가입</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>가입확인을 해주세요</h2>
				</div>
			</div>

			<div class="contents">
				<div class="joinWrap">
					<h3 class="conTit">사업자번호 가입확인</h3>
					<div class="chkType">
						<div class="radio">
							<input type="radio" @click="athType('com')" name="joinType" id="joinType1" checked="">
							<label for="joinType1">사업자</label>
						</div>
						<div class="radio">
							<input type="radio" @click="athType('per')" name="joinType" id="joinType2">
							<label for="joinType2">개인담당자</label>
						</div>
					</div>
					<p class="infoTxt">법인/개인사업자의 경우는 법인 ID를 먼저 회원 가입하여 주시기 바랍니다.</p>
					<div class="tabStyle1">
						<table>
							<caption>회원가입확인</caption>
							<colgroup>
								<col width="142">
								<col width="*">
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">사업자번호</th>
									<td>
										<div class="inpTxt">
											<input maxlength="10" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.corpNo" type="text" placeholder="-없이 연속 10자리 입력" title="사업자번호">
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="btnWrap mgt30">
						<a @click="memberChk()" class="btnType sizeS colorB"><span>확인</span></a>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
import { globalState } from "@/common/globalState";
	const store = useStore();
	const swalAlert = inject("swalAlert");
    const router = useRouter();

	const axios = inject('axios');
	const state = reactive({
		currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
		currDate: util.formatDate(new Date(), "yyyymmdd"),
		sType : 1,
        corpNo: '',
		n_ctoren : '',
		n_ctorkr : '',
		gita : '',
	});
	const athType = (type) => {
			switch (type) {
				case "com":
					state.sType = 1;
					break;
				case "per":
					state.sType = 2;
					break;
			}
	};
	const memberChk = () => {
		if(state.corpNo.length != 10){
			return swalAlert("사업자번호 10자리를 입력하세요.");
		}
		let param = {};
		param.loginSbcTypCd = state.sType;
		param.corpNo = state.corpNo;
		if(state.sType == 1){
			axios.json('/mbrChkProc.do', param).then(async function(result){
				if(result.data.state == 'Y'){
					await swalAlert(result.data.msg);
					store.commit('common/commitCorpNo', state.corpNo);
					store.commit('common/commitsType', state.sType);
					router.push({ name: 'termsCond' });
				}else{
					console.log(result.data.msg)
					return swalAlert(result.data.msg);
				}
			})
		}else{
			console.log("****")
			axios.json('/mbrChkProc.do', param).then(async function(result){
				if(result.data.state == 'Y'){
					state.n_ctorkr = result.data.n_ctorkr;
					state.n_ctoren = result.data.n_ctoren;
					state.gita = result.data.gita;
					await swalAlert(result.data.msg);
					store.commit('common/commitCorpNo', state.corpNo);
					store.commit('common/commitsType', state.sType);
					store.commit('common/corpNmKr', state.n_ctorkr.trim());
					store.commit('common/corpNmEn', state.n_ctoren.trim());
					store.commit('common/gita', state.gita.trim());
					router.push({ name: 'termsCond' });
				}else{
					console.log(result.data.msg)
					return swalAlert(result.data.msg);
				}
			})
		}

	}

</script>

<style>

</style>
